module.exports = __webpack_public_path__ + "img/vp-cc.a7fcf8ec.svg";